if (!customElements.get('product-variant-add')) {
  customElements.define(
    'product-variant-add',
    class ProductVariantQuickAdd extends HTMLElement {
      constructor() {
        super()
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
        this.variantButton = this.querySelectorAll(".card-variants .variant-add-item")
        this.variantButton.forEach(button => {
          button.addEventListener('click', this.onClickVariantQuickAdd.bind(this))
        })
      }

      onClickVariantQuickAdd(evt) {
        evt.preventDefault()

        if (evt.target.classList.contains('disable')) {
          evt.stopPropagation()
          return
        }

        const loadingElement = evt.target.children[0]
        loadingElement.classList.remove('hidden')
        
        const config = fetchConfig('javascript')
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        delete config.headers['Content-Type']

        const variantId = evt.target.id && +evt.target.id
        const formData = new FormData()
        formData.append('id', variantId)
        formData.append('quantity', 1)
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          )
          formData.append('sections_url', window.location.pathname)
          this.cart.setActiveElement(document.activeElement)
        }
        config.body = formData

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-variant-add',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              })
              return
            } else if (!this.cart) {
              window.location = window.routes.cart_url
              return
            }
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-variant-add',
                productVariantId: variantId,
                cartData: response,
              })

            this.cart.renderContents(response)
          })
          .catch((e) => {
            console.error(e)
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty')
            loadingElement.classList.add('hidden')
          })
      }
    }
  )
}
